class CartPopup extends HTMLElement {
    constructor() {
        super();
        this.wrapper = this.querySelector('.cart__popup-wrapper');
        this.wrapperInner = this.querySelector('.cart__popup-content');
        this.closeBtn = this.querySelector('.cart__popup-cart-close');
        this.contentWrapper = this.querySelector('.cart__popup-items');
        this.countContainer = this.querySelector('.cart__popup-cart-count');
        this.cartOpenBtn = document.querySelector('cart-open-button');
        this.cartBubble = document.querySelector('#cart-icon-bubble');
        this.isMulti = document.querySelector('.header-multi');
        this.timer = this.querySelector('.cart_countdown');
        this.changeEvent = new Event('cartMounted', { bubbles: true })
        this.initEventListeners();

        this.debouncedOnChange = debounce((event) => {
            this.onChange(event);
        }, 300);
        this.addEventListener('qtyUpdated', this.debouncedOnChange.bind(this));
      
        if(!this.timer.classList.contains('hidden')){
            this.initCountdown(parseInt(this.timer.getAttribute('duration')));
        }
    }

    initEventListeners(){
        this.closeBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this.close();
        })
        this.wrapper.addEventListener('click', (e) => {
            if (e.target.classList.contains('cart__popup-wrapper')) {
                e.preventDefault();
                this.close();
            }
        })
    }
    onChange(event){
        let item = event.target.closest('[item-container]');
        if (item) {
            item.classList.add('loading');
            let loader = item.querySelector('.loading-spinner')
            if (loader) {
                loader.classList.remove('hidden')
            }
        }
        this.updateQuantity(event.target.dataset.item, event.target.value);
    }
    open(){
        this.getCartItems();
    }
    show(){
        this.wrapper.classList.add('is_open');
        document.body.classList.add('cart_open');
    }
    close(){
        this.wrapper.classList.remove('is_open'); 
        this.wrapper.classList.remove('updated'); 
        document.body.classList.remove('cart_open');
    }
     
    getCartItems(){
        let sections = this.getSectionsToRender();
        fetch(`${window.shopUrl}/?sections=${sections.join(',')}`)
        .then((response) => {
            return response.text();
        })
        .then((state) => {
            const parsedState = JSON.parse(state);
            // this.contentWrapper.innerHTML = this.getSectionInnerHTML(parsedState['cart-popup-items'], '.shopify-section');
            // this.cartOpenBtn.innerHTML = this.getSectionInnerHTML(parsedState['cart-notification-button'], '.shopify-section');
            if(this.isMulti){
                this.cartBubble.innerHTML = this.getSectionInnerHTML(parsedState['cart-icon-bubble-multi']);
            }else{
                this.cartBubble.innerHTML = this.getSectionInnerHTML(parsedState['cart-icon-bubble']);
            }
            this.wrapper.innerHTML = this.getSectionInnerHTML(parsedState['cart-modal'], '.cart__popup-wrapper');
            this.initCountdown(parseInt(this.timer.getAttribute('duration')));
            this.dispatchEvent(this.changeEvent); 
        }).finally(()=>{
            this.show();
        })
        .catch((e) => {
            console.log(e);
            alert('cart api error');
        });
    }

    updateQuantity(itemId, qty){
        this.wrapper.classList.add('updated');
        const body = JSON.stringify({
            updates:{
                [itemId]: qty
            },
            sections: this.getSectionsToRender(),
            sections_url: window.location.pathname
        });
        fetch(`${routes.cart_update_url}`, {...fetchConfig('javascript'),...{ body }})
        .then((response) => {
            return response.text();
        })
        .then((state) => {
            const parsedState = JSON.parse(state);
            if(this.isMulti){
                this.cartBubble.innerHTML = this.getSectionInnerHTML(parsedState.sections['cart-icon-bubble-multi']);
            }else{
                this.cartBubble.innerHTML = this.getSectionInnerHTML(parsedState.sections['cart-icon-bubble']);
            }
            this.wrapper.innerHTML = this.getSectionInnerHTML(parsedState.sections['cart-modal'], '.cart__popup-wrapper');
            
            if(parsedState.item_count < 1){
                this.clearCountdown()
            }else{
                //this.initCountdown(parseInt(this.timer.getAttribute('duration')));
            }
            this.dispatchEvent(this.changeEvent);
        }).catch((e) => {
            console.log(e);
            alert('cart api error');
        });

    }

    clear(){
        let footer =  document.querySelector('.cart-popup-footer');
        if (!footer) return;
        let sections = this.getSectionsToRender();
        fetch(`${routes.cart_clear_url}/?sections=${sections.join(',')}`,{ ...fetchConfig('javascript')})
        .then((response) => {
            return response.text();
        })
        .then((state) => {
            const parsedState = JSON.parse(state);
            if(this.isMulti){
                this.cartBubble.innerHTML = this.getSectionInnerHTML(parsedState.sections['cart-icon-bubble-multi']);
            }else{
                this.cartBubble.innerHTML = this.getSectionInnerHTML(parsedState.sections['cart-icon-bubble']);
            }
            this.wrapper.innerHTML = this.getSectionInnerHTML(parsedState.sections['cart-modal'], '.cart__popup-wrapper');
            this.dispatchEvent(this.changeEvent);
            this.clearCountdown();
        })
        .catch((e) => {
            console.error(e);
            alert('operation failed');
        })
    }

    initCountdown(minutes, seconds=0){
        var endTime, hours,msLeft, mins, time;
        let msLeftSaved = parseInt(localStorage.getItem('ccd_countdown'));
        endTime = (+new Date) + 1000 * (60*minutes + seconds) + 500;
        if(msLeftSaved) endTime = (+new Date) + msLeftSaved;
        
        this.timerInterval = setInterval(() => {
            updateTimer();
        }, 1000);
        setTimeout(()=> {this.timer.classList.remove('hidden')}, 1001)
        
        function twoDigits( n ){return (n <= 9 ? "0" + n : n);}
        
        function updateTimer(){
          var element = document.querySelector('.cart_countdown__timer');
            msLeft = endTime - (+new Date);
            if ( msLeft < 1000 ) {
                element.innerHTML = "00:00";
                //clear?
                let cartPopup = document.querySelector('cart-popup');
                cartPopup.clearCountdown();
                cartPopup.clear();
            }
            else {
                time = new Date( msLeft );
                hours = time.getUTCHours();
                mins = time.getUTCMinutes();
                element.innerHTML = (hours ? hours + ':' + twoDigits( mins ) : mins) + ':' + twoDigits( time.getUTCSeconds() );
                let cnt = (hours ? hours + ':' + twoDigits( mins ) : mins) + ':' + twoDigits( time.getUTCSeconds() );
                localStorage.setItem('ccd_countdown', msLeft);
                endTime = (+new Date) + msLeft
            }

        }
    }
    clearCountdown(){
        clearInterval(this.timerInterval);
        localStorage.removeItem('ccd_countdown');
        this.timerInterval = null;
        this.timer.classList.add('hidden');
        console.log("clearC");
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    getSectionsToRender(){
        let r = ['cart-modal'];
        if(this.isMulti){
            r.push('cart-icon-bubble-multi')
        }else{
            r.push('cart-icon-bubble')
        }
        return r;
    }

}
customElements.define('cart-popup', CartPopup);

class CartOpenBtn extends HTMLElement {
    constructor() {
        super();
        this.cartPopup = document.querySelector('cart-popup');
        this.btn = this.querySelector('a');
        this.btn.addEventListener('click', (e) => {
            e.preventDefault();
            this.cartPopup.show();
        })
    }

}
customElements.define('cart-open-button', CartOpenBtn);

class CartCloseBtn extends HTMLElement {
    constructor() {
        super();
        this.cartPopup = document.querySelector('cart-popup');
        this.btn = this.querySelector('a');
        this.btn.addEventListener('click', (e) => {
            e.preventDefault();
            this.cartPopup.close(); 
        })
    }

}
customElements.define('cart-close-button', CartCloseBtn);

class CartRemoveBtn extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', (event) => {
            let item = event.target.closest('[item-container]');
            if (item) {
                item.classList.add('loading');
                let loader = item.querySelector('.loading-spinner')
                if (loader) {
                    loader.classList.remove('hidden')
                }
            }
            event.preventDefault();
            this.closest('cart-popup').updateQuantity(this.dataset.item, 0);
        });
    }

}
customElements.define('cart-remove-button', CartRemoveBtn);


class AddToCart extends HTMLElement {
    constructor() {
        super();
        this.cartPopup = document.querySelector('cart-popup');
        this.addEventListener('click', this.addToCart.bind(this));
    }
    addToCart(event) {
        this.variantId = this.dataset.variantId; 
        if(!this.variantId || this.hasAttribute('disabled')) return;
        this.setAttribute('disabled', true);
        let item = event.target.closest('[item-container]');
        let qty = document.querySelector(`[data-item="${this.variantId}"]`)
        if (item) {
            item.classList.add('loading');
            let loader = item.querySelector('.loading-spinner')
            if (loader) {
                loader.classList.remove('hidden')
            }
        }
        const body = JSON.stringify({
            items: [
                { 
                    quantity: qty ? parseInt(qty.value): 1,
                    id: this.variantId
                }
            ]
        });
        fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((parsedState) => {
            this.cartPopup.open();
            this.removeAttribute('disabled');
            if (item) {
                let loader = item.querySelector('.loading-spinner')
                if (loader) {
                    loader.classList.add('hidden')
                }
            }
        })
        .catch((e) => {
            console.error(e);
        })
    }

}

customElements.define('add-to-cart', AddToCart);
